<template>
  <div class="row" v-if="content.length">
    <div class="col-12">
      <Tinybox
        v-model="index"
        :images="content"
        style="z-index: 1021;"
      ></Tinybox>
    </div>
    <div class="col-md-4 mb-3" v-for="(image, index) in images" :key="index">
      <img :data-src="path(image.path)" class="img-fluid zoom lazyload" @click="select(index)"/>
    </div>
  </div>
</template>

<script>
import Tinybox from "vue-tinybox"

export default {
  components: {
    Tinybox,
  },
  props: ['images'],
  data(){return{
    index: null, 
  }},
  computed: {
    content() {
      return this.images.map(img => (this.path(img.path)))
    },
  },
  methods: {
    select(index) {
      this.index = index
    },
    path(file) {
      return `https://djceg34j53tq.cloudfront.net/${file}`
    },
  },
}
</script>

<style>
.zoom {
  cursor: zoom-in;
}
</style>